/** @deprecated Verwende DB-gestütztes Metadatenmodell (`trainingMetadata.js`, `metadata_dimensions`). */
export const DRILL_TAG_GROUP_STROKE = "tag_stroke";
/** @deprecated Verwende DB-gestütztes Metadatenmodell (`trainingMetadata.js`, `metadata_dimensions`). */
export const DRILL_TAG_GROUP_STYLE = "tag_style";
/** @deprecated Verwende DB-gestütztes Metadatenmodell (`trainingMetadata.js`, `metadata_dimensions`). */
export const DRILL_TAG_GROUP_FOCUS = "tag";

/** @deprecated Verwende `loadMetadataItems()` statt hardcodierter Gruppen. */
export const DRILL_TAG_GROUP_KEYS = [
  DRILL_TAG_GROUP_STROKE,
  DRILL_TAG_GROUP_STYLE,
  DRILL_TAG_GROUP_FOCUS,
];

/** @deprecated Fallback-Katalog – wird durch `metadata_items` ersetzt. */
export const DEFAULT_DRILL_TAG_LABELS = {
  vorhand: "Vorhand",
  rueckhand: "Rückhand",
  volley: "Volley",
  halbvolley: "Halbvolley",
  smash: "Smash",
  aufschlag: "Aufschlag",
  return: "Return",
  lob: "Lob",
  stoppball: "Stoppball",
  topspin: "Topspin",
  slice: "Slice",
  drive: "Drive",
  flat: "Flat",
  grundlinie: "Grundlinie",
  netzspiel: "Netzspiel",
  angriff: "Angriff",
  defensive: "Defensive",
  uebergang_netz: "Übergang ans Netz",
  matchsimulation: "Matchsimulation",
  doppel: "Doppel",
  technik: "Technik",
  ballgefuehl: "Ballgefühl",
  praezision: "Präzision",
  konstanz: "Konstanz",
  fussarbeit: "Fußarbeit",
  koordination: "Koordination",
  reaktion: "Reaktion",
  wettkampf: "Wettkampf",
  spass: "Spaß",
  taktik: "Taktik",
  positionierung: "Positionierung",
  formation: "Formation",
  motivation: "Motivation",
  passierschlag: "Passierschlag",
  einspielen: "Einspielen",
};

const DEFAULT_STROKE_KEYS = [
  "vorhand",
  "rueckhand",
  "volley",
  "halbvolley",
  "smash",
  "aufschlag",
  "return",
  "lob",
  "stoppball",
];
const DEFAULT_STYLE_KEYS = ["topspin", "slice", "drive", "flat"];
const DEFAULT_FOCUS_KEYS = [
  "grundlinie",
  "netzspiel",
  "angriff",
  "defensive",
  "uebergang_netz",
  "matchsimulation",
  "doppel",
  "technik",
  "ballgefuehl",
  "praezision",
  "konstanz",
  "fussarbeit",
  "koordination",
  "reaktion",
  "wettkampf",
  "spass",
  "taktik",
  "positionierung",
  "formation",
  "motivation",
  "passierschlag",
  "einspielen",
];

function __defaultItems(groupKey, keys) {
  return keys.map((itemKey, index) => ({
    groupKey,
    itemKey,
    label: DEFAULT_DRILL_TAG_LABELS[itemKey] || itemKey,
    sortOrder: index + 1,
  }));
}

export function defaultDrillTagItemsByGroup() {
  return {
    stroke: __defaultItems(DRILL_TAG_GROUP_STROKE, DEFAULT_STROKE_KEYS),
    style: __defaultItems(DRILL_TAG_GROUP_STYLE, DEFAULT_STYLE_KEYS),
    focus: __defaultItems(DRILL_TAG_GROUP_FOCUS, DEFAULT_FOCUS_KEYS),
  };
}

/**
 * @param {string} itemKey
 */
export function getDrillTagLabel(itemKey) {
  const key = String(itemKey || "").trim();
  return DEFAULT_DRILL_TAG_LABELS[key] || key;
}

/**
 * @param {object[]} items
 * @param {object[]} fallbackItems
 */
function __mergeTagItems(items, fallbackItems) {
  const byKey = new Map(
    (fallbackItems || []).map((item) => [item.itemKey, item]),
  );
  for (const item of items || []) {
    byKey.set(item.itemKey, item);
  }
  return [...byKey.values()].sort(
    (a, b) =>
      (a.sortOrder ?? 0) - (b.sortOrder ?? 0) ||
      String(a.label).localeCompare(String(b.label), "de"),
  );
}

function __drillTagItemsByGroupFromMetadata(metadata) {
  const byGroup = metadata?.itemsByGroup || {};
  return {
    stroke: byGroup[DRILL_TAG_GROUP_STROKE] || [],
    style: byGroup[DRILL_TAG_GROUP_STYLE] || [],
    focus: byGroup[DRILL_TAG_GROUP_FOCUS] || [],
  };
}

/**
 * @param {{ itemsByGroup?: Record<string, object[]> } | null | undefined} metadata
 * @param {object[]} [drills]
 */
export function getDrillTagCatalog(metadata, drills) {
  const defaults = defaultDrillTagItemsByGroup();
  const fromDb = __drillTagItemsByGroupFromMetadata(metadata);
  const catalog = {
    stroke: __mergeTagItems(fromDb.stroke, defaults.stroke),
    style: __mergeTagItems(fromDb.style, defaults.style),
    focus: __mergeTagItems(fromDb.focus, defaults.focus),
  };

  const known = new Set(
    [...catalog.stroke, ...catalog.style, ...catalog.focus].map(
      (item) => item.itemKey,
    ),
  );

  for (const drill of drills || []) {
    for (const key of resolveDrillTagKeys(drill)) {
      if (known.has(key)) continue;
      known.add(key);
      catalog.focus.push({
        groupKey: DRILL_TAG_GROUP_FOCUS,
        itemKey: key,
        label: getDrillTagLabel(key),
        sortOrder: 999,
      });
    }
  }

  return catalog;
}

/**
 * @param {{ itemsByGroup?: Record<string, object[]> } | null | undefined} metadata
 * @param {object[]} [drills]
 */
export function collectDrillTagItems(metadata, drills) {
  const catalog = getDrillTagCatalog(metadata, drills);
  return [...catalog.stroke, ...catalog.style, ...catalog.focus];
}

/**
 * @param {{ itemsByGroup?: Record<string, object[]> } | null | undefined} metadata
 * @param {object[]} [drills]
 */
export function drillTagItemsByGroup(metadata, drills) {
  return getDrillTagCatalog(metadata, drills);
}

/** Legacy i18n-Keys → item_key (exercise_metadata_items) */
export const LEGACY_DRILL_TAG_KEY_MAP = {
  "trainer.drills.tags.forehand": "vorhand",
  "trainer.drills.tags.backhand": "rueckhand",
  "trainer.drills.tags.baseline": "grundlinie",
  "trainer.drills.tags.serve": "aufschlag",
  "trainer.drills.tags.precision": "praezision",
  "trainer.drills.tags.volley": "volley",
  "trainer.drills.tags.reaction": "reaktion",
  "trainer.drills.tags.netPlay": "netzspiel",
  "trainer.drills.tags.positioning": "positionierung",
  "trainer.drills.tags.return": "return",
  "trainer.drills.tags.tactics": "taktik",
  "trainer.drills.tags.coordination": "koordination",
  "trainer.drills.tags.footwork": "fussarbeit",
  "trainer.drills.tags.warmup": "einspielen",
  "trainer.drills.tags.feel": "ballgefuehl",
  "trainer.drills.tags.competition": "wettkampf",
  "trainer.drills.tags.fun": "spass",
  "trainer.drills.tags.motivation": "motivation",
  "trainer.drills.tags.doubles": "doppel",
  "trainer.drills.tags.formation": "formation",
  "trainer.drills.tags.slice": "slice",
  "trainer.drills.tags.attack": "angriff",
  "trainer.drills.tags.passingShot": "passierschlag",
};

/**
 * @param {string} raw
 */
export function normalizeDrillTagKey(raw) {
  const key = String(raw || "").trim();
  if (!key) return "";
  if (LEGACY_DRILL_TAG_KEY_MAP[key]) return LEGACY_DRILL_TAG_KEY_MAP[key];
  if (key.startsWith("trainer.drills.tags.")) {
    const suffix = key.slice("trainer.drills.tags.".length);
    const camelToSnake = suffix
      .replace(/([A-Z])/g, "_$1")
      .toLowerCase()
      .replace(/^_/, "");
    return LEGACY_DRILL_TAG_KEY_MAP[key] || camelToSnake;
  }
  return key;
}

/**
 * @param {{ itemsByGroup?: Record<string, object[]> } | null | undefined} metadata
 * @deprecated use collectDrillTagItems(metadata, drills)
 */
export function collectDrillTagItemsFromMetadataOnly(metadata) {
  const byGroup = metadata?.itemsByGroup || {};
  return DRILL_TAG_GROUP_KEYS.flatMap((groupKey) => byGroup[groupKey] || []);
}

/**
 * @param {{ tags?: { itemKey?: string }[], tagKeys?: string[] } | null | undefined} drill
 */
export function resolveDrillTagKeys(drill) {
  const fromRel = (drill?.tags || [])
    .map((tag) => normalizeDrillTagKey(tag.itemKey || tag.item_key))
    .filter(Boolean);
  if (fromRel.length > 0) return [...new Set(fromRel)];
  const fromKeys = (drill?.tagKeys || [])
    .map(normalizeDrillTagKey)
    .filter(Boolean);
  return [...new Set(fromKeys)];
}
